Customer.Dashboard ||= {}

class Customer.Dashboard.EmailTextDetailsView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/email_text_details']

  events:
    'click #show-with-copy'           : '_onToggleWithCopy'
    'click #show-with-hidden-copy'    : '_onToggleWithHiddenCopy'
    'keyup #input_subject'            : '_updateSubjectCharCount'
    'click .email-suggestions'        : '_openSuggestionsBox'
    'change #social_accounts'         : '_keepCustomerSessionAlive'
    'keyup #input_send_to'            : '_keepCustomerSessionAlive'
    'keyup #input_with_copy'          : '_keepCustomerSessionAlive'
    'keyup #input_with_hidden_copy'   : '_keepCustomerSessionAlive'

  initialize: ({mainTextView, subjectLimit, socialAccounts, validateSubject}) ->
    @mainTextView = mainTextView
    @subjectLimit = subjectLimit
    @socialAccounts = socialAccounts
    @validateSubject = validateSubject

  render: ->
    @$el.html @template
      subjectLimit: @subjectLimit
      socialAccounts: @socialAccounts
    @

  validateAttributes: ->
    errors = []
    @_removeValidationErrors()
    @_validateSocialAccount(errors)
    @_validateSubject(errors)
    @_validateRecipient(errors)
    @_validateCC(errors)
    @_validateCCo(errors)
    errors

  getSocialAccount: ->
    @$el.find('#social_accounts').val()

  disableSubject: ->
    @$el.find('#input_subject').attr('disabled', true)

  enableSubject: ->
    @$el.find('#input_subject').attr('disabled', false)

  setSubject: (subject) ->
    @$el.find('#input_subject').val(subject)
    @$el.find('#subject-count').text(subject.length)

  getSubject: ->
    @$el.find('#input_subject').val()

  disableEmailTo: ->
    @$('#input_send_to')
      .attr('disabled', true)
      .closest('.email-input-field').find('.email-suggestions').hide()

  enableEmailTo: ->
    @$('#input_send_to')
      .attr('disabled', false)
      .closest('.email-input-field').find('.email-suggestions').show()

  getEmailTo: ->
    @$el.find('#input_send_to').val()

  addEmailTo: (toEmail) ->
    @$el.find('#input_send_to').val(toEmail)

  addBccEmails: (bccEmails) ->
    @$el.find('#input_with_hidden_copy').val(bccEmails)
    @$el.find('#with-hidden-copy-field').toggle() if bccEmails.length != 0

  addCcEmails: (ccEmails) ->
    @$el.find('#input_with_copy').val(ccEmails)
    @$el.find('#with-copy-field').show() if ccEmails.length != 0

  clearEmailTo: ->
    @$el.find('#input_send_to').val('')

  getCC: ->
    return [] if _.isEmpty(@$el.find('#input_with_copy').val()) || !@$el.find('#with-copy-field').is(":visible")
    @$el.find('#input_with_copy').val().replace(/ /g,'').split(',')

  getCCo: ->
    return [] if _.isEmpty(@$el.find('#input_with_hidden_copy').val()) || !@$el.find('#with-hidden-copy-field').is(":visible")
    @$el.find('#input_with_hidden_copy').val().replace(/ /g,'').split(',')

  _emailSocialAccounts: ->
    @_enhancedAccount(account) for account in @socialAccounts when account.email?

  _enhancedAccount: (account) ->
    _.extend {to_s: "#{account.name} (#{account.email})"}, account

  _onToggleWithCopy: ->
    @_keepCustomerSessionAlive()
    @$el.find('#with-copy-field').toggle()
    @$el.find('#show-with-copy').get(0).classList.toggle('active')

  _onToggleWithHiddenCopy: ->
    @_keepCustomerSessionAlive()
    @$el.find('#with-hidden-copy-field').toggle()
    @$el.find('#show-with-hidden-copy').get(0).classList.toggle('active')

  _updateSubjectCharCount: ->
    @_keepCustomerSessionAlive()
    value = @$el.find('#input_subject').val().length
    if value >= @subjectLimit
      @$el.find('#subject-count').addClass('limit-reached')
    else
      @$el.find('#subject-count').removeClass('limit-reached')

  _removeValidationErrors: ->
    @$el.find('.validation_error').removeClass('validation_error')

  _validateSocialAccount: (errors) ->
    socialAccountId = @$el.find('#social_accounts').val()
    return if socialAccountId != null && socialAccountId != 0
    @$el.find('#social_accounts').addClass('validation_error')
    errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.social_account'))

  _validateSubject: (errors) ->
    return unless @validateSubject
    return unless @getSubject().length == 0
    errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.subject'))
    @$el.find('#input_subject').addClass('validation_error')

  _validateRecipient: (errors) ->
    return if @_isEmail(@getEmailTo())
    @$el.find('#input_send_to').addClass('validation_error')
    if @getEmailTo().split(',').length > 1
      errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.to_mail_multiple'))
    else if @getEmailTo() == ''
      errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.to_mail_empty'))
    else
      errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.to_mail'))

  _validateCC: (errors) ->
    return if @getCC().length == 0
    return if _.every(@getCC(), (email) => @_isEmail(email))
    errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.with_copy'))
    @$el.find('#input_with_copy').addClass('validation_error')

  _validateCCo: (errors) ->
    return if @getCCo().length == 0
    return if _.every(@getCCo(), (email) => @_isEmail(email))
    errors.push(I18n.t('customer.dashboard.new_case.modal.attribute_error.with_hidden_copy'))
    @$el.find('#input_with_hidden_copy').addClass('validation_error')

  _isEmail: (email) ->
    emailRegEx = new RegExp(/// ^([\w.+-]+)@([\w.-]+)\.([a-zA-Z.]+)$ ///i)
    emailRegEx.test email

  _openSuggestionsBox: (event) ->
    suggestionsBoxView = new Customer.Dashboard.SuggestionsBoxView()
    @$('.email-suggestions-container').html suggestionsBoxView.render().el
    $input = $(event.target).closest('.email-input-field').find('input')
    @listenTo(suggestionsBoxView, 'select:option', (text) => @_fillSelectedOption(text, $input))

  _fillSelectedOption: (text, $input) ->
    return if $input.is ':disabled'
    if @_shouldAppendToInput($input)
      $input.val "#{$input.val()}, #{text}"
    else
      $input.val text

  _shouldAppendToInput: ($input) ->
    @_isMultipleInput($input) and $input.val()?.length

  _isMultipleInput: ($input) ->
    $input.data('multiple')?

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
